import React from 'react'
import BaseSearchBar from '../BaseSearchBar'

/**
 * Allows the search bar to have external value synchronization
 */
export default function SynchronizedSearchBar(props) {
  return <BaseSearchBar {...props} />
}
